import { initializeApp, getApp, getApps, type FirebaseApp } from 'firebase/app';
import { getAuth, connectAuthEmulator, GoogleAuthProvider, type Auth } from 'firebase/auth';
import { getFirestore, connectFirestoreEmulator, type Firestore } from 'firebase/firestore';
// import { getFunctions, connectFunctionsEmulator } from 'firebase/functions'; // If using Firebase Functions
// import { getStorage, connectStorageEmulator } from 'firebase/storage'; // If using Firebase Storage

const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
  measurementId: import.meta.env.VITE_FIREBASE_MEASUREMENT_ID,
};

let app: FirebaseApp | null = null;
let auth: Auth | any = {}; // Use 'any' for mock auth if no API key
let db: Firestore | any = {}; // Use 'any' for mock db if no API key
// let functions;
// let storage;

const isValidApiKey = firebaseConfig.apiKey && firebaseConfig.apiKey !== 'YOUR_API_KEY' && firebaseConfig.apiKey !== 'DEIN_ECHTER_API_KEY';

if (isValidApiKey) {
  if (!getApps().length) {
    app = initializeApp(firebaseConfig);
  } else {
    app = getApp();
  }
  auth = getAuth(app);
  db = getFirestore(app);
  // functions = getFunctions(app); // Initialize if needed
  // storage = getStorage(app); // Initialize if needed

  // Emulator Setup (for local development with valid API key but using emulators)
  if (import.meta.env.VITE_USE_FIREBASE_EMULATOR === 'true') {
    console.log('VALID API KEY found, but VITE_USE_FIREBASE_EMULATOR is true. Connecting to Firebase Emulators.');
    const authEmulatorHost = import.meta.env.VITE_FIREBASE_AUTH_EMULATOR_HOST || "127.0.0.1:9099";
    connectAuthEmulator(auth, `http://${authEmulatorHost}`, { disableWarnings: true });
    
    const firestoreEmulatorHost = import.meta.env.VITE_FIREBASE_FIRESTORE_EMULATOR_HOST || "127.0.0.1:8080";
    connectFirestoreEmulator(db, firestoreEmulatorHost.split(':')[0], parseInt(firestoreEmulatorHost.split(':')[1]));
  }
} else {
  console.warn(
    'Firebase API Key is missing or invalid. Firebase services will NOT be initialized. App is in OFFLINE/MOCK mode.\n' +
    'Please provide your Firebase config in .env for full functionality.'
  );
  // Basic mock for auth to prevent crashes in useAuthStore initialization if needed
  auth = {
    onAuthStateChanged: (callback: any) => {
      console.log("Offline Mode: onAuthStateChanged listener registered. No user will be emitted.");
      setTimeout(() => callback(null), 0); // Immediately call with no user
      return () => {}; // Return an empty unsubscribe function
    },
    // Add other methods that might be called during init if necessary to prevent errors
    // e.g. if useAuthStore immediately calls something on auth.
    // For now, onAuthStateChanged is the most critical for store init.
  };
  // db can remain an empty object or have basic mock methods if needed by firestoreService directly on load.
}

const googleAuthProvider = isValidApiKey ? new GoogleAuthProvider() : null;

export { app, auth, db, googleAuthProvider, isValidApiKey }; 